import { useRouter } from 'next/router';

import { getLocale } from 'utils/i18n.utils';

export const useLocale = () => {
  const router = useRouter();
  return getLocale(router);
};
